import { useMemo } from "react";
import { FunnelConfigTypes } from "../../../funnel/types";
import { useIsInReader } from "../../../../hooks/useIsInReader";
import { useReleasePurchaseFlow } from "../../../../hooks/useReleasePurchaseFlow";
import { setFunnelModalConfig } from "../../../funnel/FunnelModal";

export function useReleaseInfoPaywall({
  setFunnelConfig,
}: {
  setFunnelConfig: (config?: FunnelConfigTypes) => void;
}) {
  const inReader = useIsInReader();

  // In reader: use global modal. Outside reader: use inline funnel in slide-in menu
  const funnelConfigSetter = inReader ? setFunnelModalConfig : setFunnelConfig;
  const options = useMemo(() => ({ isModal: inReader }), [inReader]);

  return useReleasePurchaseFlow({
    setFunnelConfig: funnelConfigSetter,
    options,
  });
}
